<template>
  <div align="left" v-tap="(e) => BtnClick()">
    <v-tooltip bottom color="primary">
      <template slot="activator" slot-scope="{ on }">
        <v-btn icon v-on="on">
          <v-icon :color="color" x-large>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span v-if="toolTip === '' || toolTip === null">{{ $t("back") }}</span>
      <span v-else>{{ $t(toolTip) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    color: {
      type: String,
      default: "primary"
    },
    toolTip: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "mdi-arrow-left"
    }
  },
  methods: {
    back() {
      this.$emit("click");
    },
    BtnClick() {
      this.back();
    }
  }
};

//@ sourceURL=backButton.js
</script>

<style></style>
